var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('b-container',[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('div',[_vm._v("Verifying details.")])])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }